currentSelectedVehicle = fitmentData.currentVehicle;

const modalMobile = document.getElementById("fitment_modal_mobile");
const btnMobile = document.getElementById("fitment_btn_mobile");
const spanMobile = document.querySelector(".close_mobile");

btnMobile.onclick = function () {
  modalMobile.style.display = "block";

  window.kortx("ktrack", "submitLead", {
    contentId: "Lead",
    contentType: "Select my Ride",
    kid: "35071488$1728522", // DO NOT EDIT
  });
};

spanMobile.onclick = function () {
  modalMobile.style.display = "none";
};

function processFitmentsMobile(currentSelectedVehicle) {
  let param = "";
  let info = "";

  for (const [key, value] of Object.entries(currentSelectedVehicle)) {
    if (key === "year") {
      getFitmentsMobile("").then((data) => {
        if (Object.keys(data.result).length > 0) {
          makeFitmentSelectShared(
            Object.keys(data.result)[0],
            data.result.year.reverse(),
            value,
            true
          );
        }
      });
      param = `${key}=${value}`;
    } else {
      getFitmentsMobile(param).then((data) => {
        if (
          Object.keys(data.result).length > 0 &&
          Object.keys(data.result)[0] !== "sku"
        ) {
          makeFitmentSelectShared(
            Object.keys(data.result)[0],
            data.result[Object.keys(data.result)[0]],
            value,
            true
          );
        }
      });
      param += `&${key}=${value}`;
    }

    info += `${value} `;
  }

  const fitmentHeaderMobile = document.querySelector(
    ".fitment_header_mobile strong"
  );
  fitmentHeaderMobile.textContent = info.trim();
  fitmentHeaderMobile.style.fontSize = "13px";

  const fitmentBtnMobile = document.getElementById("fitment_btn_mobile");
  fitmentBtnMobile.textContent = "Change";
  fitmentBtnMobile.disabled = false;

  document.querySelector(".fitment_shop_btn_mobile").disabled = false;
  document.querySelector(".fitment_clear_btn_mobile").style.display = "block";

  fitmentData.currentVehicle = currentSelectedVehicle;
  saveFitmentData();
}

if (isEmpty(currentSelectedVehicle)) {
  const fitmentHeaderMobile = document.querySelector(
    ".fitment_header_mobile strong"
  );
  const fitmentBtnMobile = document.getElementById("fitment_btn_mobile");

  fitmentHeaderMobile.textContent = "Shop by vehicle";
  fitmentHeaderMobile.style.fontSize = "15px";
  fitmentBtnMobile.textContent = "+ select my ride";
  fitmentBtnMobile.disabled = false;

  getFitmentsMobile("").then((data) => {
    if (Object.keys(data.result).length > 0) {
      makeFitmentSelectShared(
        Object.keys(data.result)[0],
        data.result.year.reverse(),
        "",
        true
      );
    }
  });
} else {
  processFitmentsMobile(currentSelectedVehicle);
}

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

async function getFitmentsMobile(param) {
  const store_id = "crawltek";
  let url = `https://fitmentapi.azurewebsites.net/api/ymm?store_id=${store_id}`;

  if (param) {
    if (!param.startsWith("&")) {
      param = "&" + param;
    }
    url += param;
  }

  // Check if we have cached data for this param
  if (fitmentData.dropdownData[param]) {
    return { result: fitmentData.dropdownData[param] };
  }

  const res = await fetch(url, { method: "GET" });
  const data = await res.json();

  // Cache the result
  fitmentData.dropdownData[param] = data.result;
  fitmentData.lastUpdated = new Date().getTime();
  saveFitmentData();

  return data;
}

function saveFitmentData() {
  localStorage.setItem("fitmentData", JSON.stringify(fitmentData));
}

function getFitmentData() {
  const storedData = localStorage.getItem("fitmentData");
  if (storedData) {
    const parsedData = JSON.parse(storedData);
    const now = new Date().getTime();
    const threeDaysInMs = 3 * 24 * 60 * 60 * 1000;

    if (now - parsedData.lastUpdated < threeDaysInMs) {
      return parsedData;
    }
  }
  return null;
}

// The rest of the functions (makeFitmentSelectMobile, makeFitmentParamMobile, etc.) remain largely unchanged

$(document).on("change", ".fitment_select_mobile", function () {
  const validSelectArr = [
    "year",
    "make",
    "model",
    "submodel",
    "drive_type",
    "fuel_type",
    "doors",
  ];

  const id = $(this).attr("id").replace("_mobile", "");

  if (validSelectArr.includes(id)) {
    currentSelectedVehicle[id] = $(this).val();
    fitmentData.currentVehicle = currentSelectedVehicle;
    saveFitmentData();

    getFitmentsMobile(makeFitmentParamMobile(id)).then((data) => {
      const resultKeys = Object.keys(data.result);
      const resultLength = resultKeys.length;

      if (
        resultLength > 0 &&
        resultKeys[0] !== "doors" &&
        resultKeys[0] !== "type" &&
        data.result[resultKeys[0]].length > 0
      ) {
        makeFitmentSelectShared(
          resultKeys[0],
          data.result[resultKeys[0]],
          "",
          true
        );
        document.querySelector(".fitment_shop_btn_mobile").disabled = true;
        document.querySelector(".fitment_clear_btn_mobile").style.display =
          "none";
      } else {
        document.querySelector(".fitment_shop_btn_mobile").disabled = false;
        document.querySelector(".fitment_clear_btn_mobile").style.display =
          "block";
      }
    });
  }
});

let fitmentShopBtnMobile = document.querySelector(".fitment_shop_btn_mobile");
if (fitmentShopBtnMobile) {
  fitmentShopBtnMobile.addEventListener("click", function () {
    let info = "";
    for (const [k, v] of Object.entries(currentSelectedVehicle)) {
      info += v + " ";
    }

    document.querySelector(".fitment_info").textContent = info;
    const header = document.querySelector(".collection_details_header h1");
    if (header) header.textContent = info + " All Products";
    document.querySelector(".fitment_info_container").style.display = "block";
    document.querySelector(".fitment_header").style.display = "none";
    document.querySelector(".fitment_header_mobile strong").textContent = info;
    document.getElementById("fitment_btn_mobile").textContent = "Change";

    fitmentData.currentVehicle = currentSelectedVehicle;
    saveFitmentData();

    modalMobile.style.display = "none";

    if (
      !window.location.href.includes("/collections/") &&
      !window.location.href.includes("/products/") &&
      !window.location.href.includes("search?q=")
    ) {
      window.location.href = "/pages/product-fitment-search";
    } else if (
      window.location.href.includes("collections") ||
      window.location.href.includes("search?q=")
    ) {
      location.reload();
    }
  });
}

function makeFitmentParamMobile(type) {
  let param = "";
  let isAdding = true;
  let keyArray = [];
  for (const [k, v] of Object.entries(currentSelectedVehicle)) {
    if (isAdding) {
      param += k + "=" + v + "&";
      keyArray.push(k);
    } else {
      delete currentSelectedVehicle[k];
    }
    if (k == type) {
      isAdding = false;
    }
  }
  document.querySelectorAll(".fitment_select_mobile").forEach((element) => {
    if (!keyArray.includes(element.id.replace("_mobile", ""))) {
      let id = element.id.replace("_mobile", "");
      if (id == "make" || id == "model") {
        document
          .getElementById(id + "_mobile")
          .querySelectorAll("option:not(:first-child)")
          .forEach((option) => option.remove());
        document.getElementById(id + "_mobile").disabled = true;
      } else {
        element.remove();
      }
    }
  });

  return param.slice(0, -1);
}

function clearFitmentDataMobile() {
  fitmentData = {
    currentVehicle: {},
    dropdownData: {},
    lastUpdated: null,
  };
  currentSelectedVehicle = {};
  saveFitmentData();

  document.querySelector(".fitment_info").textContent = "";
  document.querySelector(".fitment_info_container").style.display = "none";
  document.querySelector(".fitment_header_mobile strong").textContent =
    "Shop by vehicle";
  document.getElementById("fitment_btn_mobile").textContent =
    "+ select my ride";
  document.querySelector(".fitment_header").style.display = "block";

  document.querySelectorAll(".fitment_select_mobile").forEach((el) => {
    const id = el.id.replace("_mobile", "");
    if (id == "year" || id == "make" || id == "model") {
      document.getElementById(id + "_mobile").innerHTML = "";
      document.getElementById(id + "_mobile").disabled = true;
    } else {
      el.remove();
    }
  });

  getFitmentsMobile("").then((data) => {
    if (Object.keys(data.result).length > 0) {
      makeFitmentSelectShared(
        Object.keys(data.result)[0],
        data.result.year.reverse(),
        "",
        true
      );
    }
  });

  document.querySelector(".fitment_shop_btn_mobile").disabled = true;
  document.querySelector(".fitment_clear_btn_mobile").style.display = "none";
}

document.addEventListener("click", function (event) {
  if (event.target.matches(".popular_vehicles_mobile a")) {
    document
      .querySelectorAll(".popular_collection_details_mobile")
      .forEach((element) => element.classList.add("hidden"));

    const vehicle = event.target.textContent;
    document
      .querySelectorAll(".popular_collection_details_mobile")
      .forEach((element) => {
        if (vehicle.split(" ").every((i) => element.classList.contains(i))) {
          element.classList.remove("hidden");
        }
      });

    document
      .querySelectorAll(".popular_vehicles_mobile a")
      .forEach((element) => element.classList.remove("active"));
    event.target.classList.add("active");
  }
});

let btnContainerMobileP = document.querySelector(".btn_container_mobile p");
if (btnContainerMobileP) {
  btnContainerMobileP.addEventListener("click", clearFitmentDataMobile);
}

let fimentClearMobile = document.querySelector(".fitment_clear_mobile");
if (fimentClearMobile) {
  fimentClearMobile.addEventListener("click", function () {
    clearFitmentDataMobile();

    if (
      window.location.href.includes("collections") ||
      window.location.href.includes("search?q=")
    ) {
      location.reload();
    }
  });
}

class StickyHeaderMobile extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector(".section-header-mobile");
    this.headerIsAlwaysSticky =
      this.getAttribute("data-sticky-type") === "always" ||
      this.getAttribute("data-sticky-type") === "reduce-logo-size";
    this.headerBounds = {};

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add("shopify-section-header-sticky");
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector("predictive-search");

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add("scrolled-past-header");
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add("scrolled-past-header");
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove("scrolled-past-header");
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky"
    );
    this.header.style.top = "";
  }

  reveal() {
    const headerMultiSite = document.querySelector(
      ".section-header-nav-multi-site"
    );
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add("shopify-section-header-sticky", "animate");
    this.header.classList.remove("shopify-section-header-hidden");
    if (headerMultiSite) {
      const height = headerMultiSite.offsetHeight;
      this.header.style.top = `${height}px`;
    }
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "animate"
    );
    this.header.style.top = "";
  }
}

customElements.define("sticky-header-mobile", StickyHeaderMobile);

// const modalMobile = document.getElementById('fitment_modal_mobile')
// const btnMobile = document.getElementById('fitment_btn_mobile')
// const spanMobile = document.querySelector('.close_mobile')

// btnMobile.onclick = function () {
//   modalMobile.style.display = 'block'

//   // Assuming window.kortx is a global function
//   window.kortx('ktrack', 'submitLead', {
//     contentId: 'Lead',
//     contentType: 'Select my Ride',
//     kid: '35071488$1728522', // DO NOT EDIT
//   })
// }

// spanMobile.onclick = function () {
//   modalMobile.style.display = 'none'
// }

// function processFitmentsMobile(currentSelectedVehicle) {
//   let param = ''; // Query parameters to send to the API
//   let info = '';  // String to display selected vehicle info

//   // Iterate over each key-value pair in currentSelectedVehicle
//   for (const [key, value] of Object.entries(currentSelectedVehicle)) {

//     // If the current key is 'year'
//     if (key === 'year') {
//       // Fetch fitment data for an empty parameter
//       getFitmentsMobile('').then((data) => {
//         // Check if there are any results
//         if (Object.keys(data.result).length > 0) {
//           // Populate the 'year' dropdown with the received data
//           makeFitmentSelectMobile(
//             Object.keys(data.result)[0], // First key from the result, should be 'year'
//             data.result.year.reverse(), // Reverse the order of years for selection
//             value // Current selected value
//           );
//         }
//       });
//       // Set the initial parameter to the 'year' key-value pair
//       param = `${key}=${value}`;
//     } else {
//       // Fetch fitment data using the accumulated parameters
//       getFitmentsMobile(param).then((data) => {
//         // Check if there are any results and it's not 'sku'
//         if (
//           Object.keys(data.result).length > 0 &&
//           Object.keys(data.result)[0] !== 'sku'
//         ) {
//           // Populate the dropdown for the current key with the received data
//           makeFitmentSelectMobile(
//             Object.keys(data.result)[0], // First key from the result
//             data.result[Object.keys(data.result)[0]], // Data for the current key
//             value // Current selected value
//           );
//         }
//       });
//       // Append the current key-value pair to the query parameters
//       param += `&${key}=${value}`;
//     }

//     // Accumulate the selected values into a string for display
//     info += `${value} `;
//   }

//   // Update the mobile fitment header with the selected vehicle info
//   const fitmentHeaderMobile = document.querySelector('.fitment_header_mobile strong');
//   fitmentHeaderMobile.textContent = info.trim(); // Remove trailing space and update text
//   fitmentHeaderMobile.style.fontSize = '13px'; // Adjust font size

//   // Update the 'Change' button text and enable the 'Shop' button
//   const fitmentBtnMobile = document.getElementById('fitment_btn_mobile');
//   fitmentBtnMobile.textContent = 'Change'; // Update button text to 'Change'
//   fitmentBtnMobile.disabled = false; // Enable the button

//   // Enable the 'Shop' button and show the 'Clear' button
//   document.querySelector('.fitment_shop_btn_mobile').disabled = false;
//   document.querySelector('.fitment_clear_btn_mobile').style.display = 'block';
// }

// if (isEmpty(currentSelectedVehicle)) {
//   const fitmentHeaderMobile = document.querySelector(
//     '.fitment_header_mobile strong'
//   )
//   const fitmentBtnMobile = document.getElementById('fitment_btn_mobile')

//   fitmentHeaderMobile.textContent = 'Shop by vehicle'
//   fitmentHeaderMobile.style.fontSize = '15px'
//   fitmentBtnMobile.textContent = '+ select my ride'
//   fitmentBtnMobile.disabled = false

//   getFitmentsMobile('').then((data) => {
//     if (Object.keys(data.result).length > 0) {
//       makeFitmentSelectMobile(
//         Object.keys(data.result)[0],
//         data.result.year.reverse()
//       )
//     }
//   })
// } else {
//   processFitmentsMobile(currentSelectedVehicle)
// }

// function isEmpty(obj) {
//   for (const prop in obj) {
//     if (Object.hasOwnProperty.call(obj, prop)) {
//       return false
//     }
//   }
//   return true
// }

// async function getFitmentsMobile(param) {
//   const store_id = 'crawltek';
//   let url = `https://fitmentapi.azurewebsites.net/api/ymm?store_id=${store_id}`;

//   // Ensure param starts with '&' if not empty
//   if (param) {
//     if (!param.startsWith('&')) {
//       param = '&' + param;
//     }
//     url += param;
//   }

//   const res = await fetch(url, { method: 'GET' });
//   return res.json();
// }

// function makeFitmentSelectMobile(id, optionArray, v) {
//   const filteredOptions = removeDuplicates(optionArray)
//   if (filteredOptions.length > 1) {
//     if (id === 'year' || id === 'make' || id === 'model') {
//       let html = ''
//       filteredOptions.forEach((option) => {
//         if (id === 'year') {
//           html +=
//             '<option class="fitment_option_mobile" ' +
//             (option.toString() === v.toString() ? 'selected' : '') +
//             '>' +
//             option +
//             '</option>'
//         } else {
//           html +=
//             '<option class="fitment_option_mobile" ' +
//             (option === v ? 'selected' : '') +
//             '>' +
//             option +
//             '</option>'
//         }
//       })
//       document
//         .getElementById(id + '_mobile')
//         .insertAdjacentHTML('beforeend', html)
//       document.getElementById(id + '_mobile').removeAttribute('disabled')
//     } else {
//       let html =
//         `<select id="${id}_mobile" class="fitment_select_mobile select__select">` +
//         `<option selected hidden>${
//           id == 'drive_type'
//             ? 'Drive Type'
//             : id == 'fuel_type'
//             ? 'Fuel Type'
//             : id.charAt(0).toUpperCase() + id.slice(1)
//         }</option>`
//       filteredOptions.forEach((option) => {
//         html += `<option class="fitment_option_mobile" ${
//           option === v ? 'selected' : ''
//         }>${option}</option>`
//       })
//       document
//         .querySelector('.select_container_mobile')
//         .insertAdjacentHTML('beforeend', html + '</select>')
//     }
//   } else {
//     if (id == 'year' || id == 'make' || id == 'model') {
//       let html = ''
//       if (id === 'year') {
//         html +=
//           '<option class="fitment_option_mobile" selected>' +
//           filteredOptions[0] +
//           '</option>'
//       } else {
//         html +=
//           '<option class="fitment_option_mobile" selected>' +
//           filteredOptions[0] +
//           '</option>'
//       }
//       $('#' + id + '_mobile').append(html)
//       $('#' + id + '_mobile').attr('disabled', false)
//     } else {
//       let html =
//         '<select id="' +
//         id +
//         '_mobile" class="fitment_select_mobile select__select">' +
//         '<option selected hidden>' +
//         (id == 'drive_type'
//           ? 'Drive Type'
//           : id == 'fuel_type'
//           ? 'Fuel Type'
//           : id.charAt(0).toUpperCase() + id.slice(1)) +
//         '</option>'
//       html +=
//         '<option  class="fitment_option_mobile" selected>' +
//         filteredOptions[0] +
//         '</option>'
//       $('.select_container_mobile').append(html + '</select>')
//     }

//     if (!v) {
//       var event_mobile = new Event('change', {
//         bubbles: true,
//         cancelable: true,
//       })
//       document.getElementById(id + '_mobile').dispatchEvent(event_mobile)
//     }
//   }
// }

// function makeFitmentParamMobile(type) {
//   let param = ''
//   let isAdding = true
//   let keyArray = []
//   for (const [k, v] of Object.entries(currentSelectedVehicle)) {
//     if (isAdding) {
//       param += k + '=' + v + '&'
//       keyArray.push(k)
//     } else {
//       delete currentSelectedVehicle[k]
//     }
//     if (k == type) {
//       isAdding = false
//     }
//   }
//   document.querySelectorAll('.fitment_select_mobile').forEach((el) => {
//     const id = el.id.replace('_mobile', '')
//     if (!keyArray.includes(id)) {
//       if (id == 'make' || id == 'model') {
//         document
//           .getElementById(id + '_mobile')
//           .querySelectorAll('option[class="fitment_option_mobile"]')
//           .forEach((option) => option.remove())
//         document.getElementById(id + '_mobile').setAttribute('disabled', true)
//       } else {
//         el.remove()
//       }
//     }
//   })

//   return param.slice(0, -1)
// }

// $(document).on('change', '.fitment_select_mobile', function () {
//   const validSelectArr = [
//     'year',
//     'make',
//     'model',
//     'submodel',
//     'drive_type',
//     'fuel_type',
//     'doors' // Make sure 'doors' is included for proper handling
//   ];

//   const id = $(this).attr('id').replace('_mobile', '');

//   if (validSelectArr.includes(id)) {
//     currentSelectedVehicle[id] = $(this).val();

//     getFitmentsMobile(makeFitmentParamMobile(id)).then((data) => {
//       const resultKeys = Object.keys(data.result);
//       const resultLength = resultKeys.length;

//       if (
//         resultLength > 0 &&
//         resultKeys[0] !== 'doors' &&
//         resultKeys[0] !== 'type' &&
//         data.result[resultKeys[0]].length > 0
//       ) {
//         makeFitmentSelectMobile(resultKeys[0], data.result[resultKeys[0]]);
//         document.querySelector('.fitment_shop_btn_mobile').disabled = true;
//         document.querySelector('.fitment_clear_btn_mobile').style.display = 'none';
//       } else {
//         // Enable the "Shop" button when no more data is available or processing reaches final valid selection
//         document.querySelector('.fitment_shop_btn_mobile').disabled = false;
//         document.querySelector('.fitment_clear_btn_mobile').style.display = 'block';
//       }
//     });
//   }
// });

// document.addEventListener('click', function (event) {
//   if (event.target.matches('.popular_vehicles_mobile a')) {
//     document
//       .querySelectorAll('.popular_collection_details_mobile')
//       .forEach((element) => element.classList.add('hidden'))

//     const vehicle = event.target.textContent
//     document
//       .querySelectorAll('.popular_collection_details_mobile')
//       .forEach((element) => {
//         if (vehicle.split(' ').every((i) => element.classList.contains(i))) {
//           element.classList.remove('hidden')
//         }
//       })

//     document
//       .querySelectorAll('.popular_vehicles_mobile a')
//       .forEach((element) => element.classList.remove('active'))
//     event.target.classList.add('active')
//   }
// })

// let fitmentShopBtnMobile = document.querySelector('.fitment_shop_btn_mobile')
// if (fitmentShopBtnMobile) {
//   fitmentShopBtnMobile.addEventListener('click', function () {
//     let info = ''
//     for (const [k, v] of Object.entries(currentSelectedVehicle)) {
//       info += v + ' '
//     }

//     document.querySelector('.fitment_info').textContent = info
//     const header = document.querySelector('.collection_details_header h1')
//     if (header) header.textContent = info + ' All Products'
//     document.querySelector('.fitment_info_container').style.display = 'block'
//     document.querySelector('.fitment_header').style.display = 'none'
//     document.querySelector('.fitment_header_mobile strong').textContent = info
//     document.getElementById('fitment_btn_mobile').textContent = 'Change'
//     localStorage.setItem('fitment', JSON.stringify(currentSelectedVehicle))
//     modalMobile.style.display = 'none'

//     if (
//       !window.location.href.includes('/collections/') &&
//       !window.location.href.includes('/products/') &&
//       !window.location.href.includes('search?q=')
//     ) {
//       window.location.href = '/pages/product-fitment-search'
//     } else if (
//       window.location.href.includes('collections') ||
//       window.location.href.includes('search?q=')
//     ) {
//       location.reload()
//     }
//   })
// }

// let btnContainerMobileP = document.querySelector('.btn_container_mobile p')
// if (btnContainerMobileP) {
//   btnContainerMobileP.addEventListener('click', function () {
//     currentSelectedVehicle = {}
//     localStorage.removeItem('fitment')
//     document.querySelector('.fitment_info').textContent = ''
//     document.querySelector('.fitment_info_container').style.display = 'none'
//     document.querySelector('.fitment_header_mobile strong').textContent =
//       'Shop by vehicle'
//     document.getElementById('fitment_btn_mobile').textContent =
//       '+ select my ride'
//     document.querySelector('.fitment_header').style.display = 'block'

//     document.querySelectorAll('.fitment_select_mobile').forEach((el) => {
//       const id = el.id.replace('_mobile', '')
//       if (id == 'year' || id == 'make' || id == 'model') {
//         document.getElementById(id + '_mobile').innerHTML = ''
//         document.getElementById(id + '_mobile').disabled = true
//       } else {
//         el.remove()
//       }
//     })

//     getFitmentsMobile('').then((data) => {
//       if (Object.keys(data.result).length > 0) {
//         makeFitmentSelectMobile(
//           Object.keys(data.result)[0],
//           data.result.year.reverse()
//         )
//       }
//     })

//     document.querySelector('.fitment_shop_btn_mobile').disabled = true
//     document.querySelector('.fitment_clear_btn_mobile').style.display = 'none'
//   })
// }

// let fimentClearMobile = document.querySelector('.fitment_clear_mobile')
// if (fimentClearMobile) {
//   fimentClearMobile.addEventListener('click', function () {
//     currentSelectedVehicle = {}
//     localStorage.removeItem('fitment')
//     document.querySelector('.fitment_info_container').style.display = 'none'
//     document.querySelector('.fitment_header_mobile strong').textContent =
//       'Shop by vehicle'
//     document.getElementById('fitment_btn_mobile').textContent =
//       '+ select my ride'

//     getFitmentsMobile('').then((data) => {
//       if (Object.keys(data.result).length > 0) {
//         makeFitmentSelectMobile(
//           Object.keys(data.result)[0],
//           data.result.year.reverse()
//         )
//       }
//     })

//     document.querySelector('.fitment_shop_btn_mobile').disabled = true
//     document.querySelector('.fitment_clear_btn_mobile').style.display = 'none'

//     if (
//       window.location.href.includes('collections') ||
//       window.location.href.includes('search?q=')
//     ) {
//       location.reload()
//     }
//   })
// }

// class StickyHeaderMobile extends HTMLElement {
//   constructor() {
//     super()
//   }

//   connectedCallback() {
//     this.header = document.querySelector('.section-header-mobile')
//     this.headerIsAlwaysSticky =
//       this.getAttribute('data-sticky-type') === 'always' ||
//       this.getAttribute('data-sticky-type') === 'reduce-logo-size'
//     this.headerBounds = {}

//     if (this.headerIsAlwaysSticky) {
//       this.header.classList.add('shopify-section-header-sticky')
//     }

//     this.currentScrollTop = 0
//     this.preventReveal = false
//     this.predictiveSearch = this.querySelector('predictive-search')

//     this.onScrollHandler = this.onScroll.bind(this)
//     this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

//     this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
//     window.addEventListener('scroll', this.onScrollHandler, false)

//     this.createObserver()
//   }

//   disconnectedCallback() {
//     this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
//     window.removeEventListener('scroll', this.onScrollHandler)
//   }

//   createObserver() {
//     let observer = new IntersectionObserver((entries, observer) => {
//       this.headerBounds = entries[0].intersectionRect
//       observer.disconnect()
//     })

//     observer.observe(this.header)
//   }

//   onScroll() {
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop

//     if (this.predictiveSearch && this.predictiveSearch.isOpen) return

//     if (
//       scrollTop > this.currentScrollTop &&
//       scrollTop > this.headerBounds.bottom
//     ) {
//       this.header.classList.add('scrolled-past-header')
//       if (this.preventHide) return
//       requestAnimationFrame(this.hide.bind(this))
//     } else if (
//       scrollTop < this.currentScrollTop &&
//       scrollTop > this.headerBounds.bottom
//     ) {
//       this.header.classList.add('scrolled-past-header')
//       if (!this.preventReveal) {
//         requestAnimationFrame(this.reveal.bind(this))
//       } else {
//         window.clearTimeout(this.isScrolling)

//         this.isScrolling = setTimeout(() => {
//           this.preventReveal = false
//         }, 66)

//         requestAnimationFrame(this.hide.bind(this))
//       }
//     } else if (scrollTop <= this.headerBounds.top) {
//       this.header.classList.remove('scrolled-past-header')
//       requestAnimationFrame(this.reset.bind(this))
//     }

//     this.currentScrollTop = scrollTop
//   }

//   hide() {
//     if (this.headerIsAlwaysSticky) return
//     this.header.classList.add(
//       'shopify-section-header-hidden',
//       'shopify-section-header-sticky'
//     )
//     this.header.style.top = ''
//   }

//   reveal() {
//     const headerMultiSite = document.querySelector(
//       '.section-header-nav-multi-site'
//     )
//     if (this.headerIsAlwaysSticky) return
//     this.header.classList.add('shopify-section-header-sticky', 'animate')
//     this.header.classList.remove('shopify-section-header-hidden')
//     if (headerMultiSite) {
//       const height = headerMultiSite.offsetHeight
//       this.header.style.top = `${height}px`
//     }
//   }

//   reset() {
//     if (this.headerIsAlwaysSticky) return
//     this.header.classList.remove(
//       'shopify-section-header-hidden',
//       'shopify-section-header-sticky',
//       'animate'
//     )
//     this.header.style.top = ''
//   }
// }

// customElements.define('sticky-header-mobile', StickyHeaderMobile)
